import script from "./ManageNews.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageNews.vue?vue&type=script&setup=true&lang=ts"

import "./ManageNews.vue?vue&type=style&index=0&id=339b9516&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339b9516"]])

export default __exports__